/*eslint-disable*/

export const EDIT_FORM_FIELDS_CONFIG = {
    showApplication: false,
}